<template>
  <div class="m_about_audience project_detail">
    <mt-header title="Exhibitor Favorites">
      <span slot="left" @click="()=>this.$router.back()">
        <i class="iconfont icon-left"></i>
        Return
      </span>
    </mt-header>
    <ul class="ul_list" v-if="tableData.list.length">
      <li class="li_item" v-for="item in tableData.list" :key="item.id">
        <div class="avatar">
          <img :src="item.img" alt=""/>
        </div>
        <div class="information">
          <p class="user_name">
            <span>{{item.name}}</span>
            {{item.duties}}
          </p>
          <p>{{item.corpname}}</p>
          <p>Meeting Time：{{item.date}}</p>
          <p>Leave a Message：{{item.connet}}</p>
        </div>
        <div class="operation">
          <el-button class="btn1" :disabled="item.status*1!=0" @click="isCollect(item.id)">Ignore</el-button>
          <el-button class="btn2" @click="reception(item.id)">{{item.status*1==0?"Confirm":"Confirmed"}}</el-button>
          <a :href="'tel:'+item.mobile"><img :src="hrefurl+'/public/icon/dajian.png'" alt=""/></a>
        </div>

      </li>
    </ul>
    <div v-else class="zanwu">
      <div><img :src="hrefurl+'/public/icon/without.png'" alt=""/></div>
      <p class="p"> No data is available!</p>
    </div>
  </div>
</template>

<script>
import { Header } from 'mint-ui';
import { reqMyCorpAppMy, reqCorpAppStatus, reqCorpAppNeglect, } from "../../../../api";
export default {
  components:{
    'mt-header':Header
  },
  data(){
    return{
      tableData:{list:[]}
    }
  },
  mounted(){
    this.init()
  },
  methods:{
    async init(){
      const response = await reqMyCorpAppMy()
      // console.log(response);
      if (response.code*1==2) {
        this.tableData={
          list:response.reslist
        }
      }else{
        // this.err(this,'请求失败，稍后重试...')
      }
    },
    async reception(id){//确认
      const response = await reqCorpAppStatus(id)
      // console.log(response);
      if (response.code*1==3) {
        // this.success(this,"Received")
        this.init()
      }
    },
    async isCollect(id){//忽略
      const response = await reqCorpAppNeglect(id)
      if (response.code==3) {
        let index = this.tableData.list.findIndex(item=>item.id==id)
        if (index>=0) {
          let {tableData} =this
          tableData.list.splice(index,1)
          this.tableData = tableData
        }
      }
    },
  }
}
</script>

<style scoped>
  .li_item{
    display: flex;
    padding: 10px;
    background-color: white;
    margin-top: 10px;
    /* font-size: 14px; */
  }
  .avatar{
    width: 50px;
    padding-right: 10px;
  }

  .information{
    width: calc(100% - 180px);
  }
  .information p{
    line-height: 20px;
    color: #333;
  }
  .operation button{
    padding: 6px;
    border: none;
    border-radius: 0;
    border-right: 1px solid #333;
    font-size: 14px;
  }
  .m_about_audience>>>.el-button:focus,.m_about_audience>>>.el-button:hover{
    background-color: transparent;
    color: #333;
    border-right-color: #333;
  }
  .operation .btn1:focus,.operation .btn1:hover{
    color:#c0c4cc;
  }
  .m_about_audience>>>.el-button{
    margin: 0;
  }
  .operation{
    width: 130px;
  }
  .operation img{
    width: 28px;
  }

    /* 空 */
  .zanwu{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -70%);
    width: 240px;
    text-align: center;
  }
</style>